module.exports = __webpack_public_path__ + "img/furiosa.da5a28f7.png";